import { render } from "./LoadindView.vue?vue&type=template&id=bcf07836"
const script = {}

import exportComponent from "C:\\Users\\USER\\Projects\\qrcode_llf\\qrcode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__